import{Fonts as e}from"@vds-core/typography";import{calculateRem as o}from"@vds-core/utilities";import{ColorTokens as r}from"@vds-tokens/color";import{FormControlsTokens as n}from"@vds-tokens/form-controls";import{TypographyTokens as t}from"@vds-tokens/typography";import i,{css as a}from"styled-components";const l=function(e){return"string"==typeof e?e:o(e)},d=i.div.withConfig({displayName:"RadioBoxLabelWrapper",componentId:"VDS__sc-pgy560-0"})`
  align-items: center;
  border-radius: ${n.border.radius.value};
  border: ${function({surface:e}){return`1px solid ${"dark"===e?n.color.border.ondark.value:n.color.border.onlight.value}`}};
  display: block;
  flex: ${function(e){return"vertical"===e.orientation?"1 1 auto":e.width?`0 0 ${l(e.width)}`:"1"}};
  font-size: ${o(t.fontsize.body[16].value)};
  letter-spacing: ${o(t.letterspacing.wide.value)};
  line-height: ${o(t.lineheight.body[20].value)};
  font-family: ${e.VerizonNHGeDS};
  height: 100%;
  min-height: ${function({height:e}){return e||o(44)}};
  position: relative;
  width: ${function(e){return e.width?l(e.width):"100%"}};
  max-width: 100%;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  background-color: ${function({surface:e,$transparentBackground:o}){return o?"transparent":"dark"===e?n.color.background.ondark.value:n.color.background.onlight.value}};
  color: ${function({disabled:e,surface:o}){return e?"dark"===o?r.interactive.disabled.ondark.value:r.interactive.disabled.onlight.value:"dark"===o?r.elements.primary.ondark.value:r.elements.primary.onlight.value}};

  ${function({disabled:e,surface:o}){return e&&`\n    border-color: ${"dark"===o?r.interactive.disabled.ondark.value:r.interactive.disabled.onlight.value}`}};

  ${function({disabled:e,checked:t,surface:i}){return!e&&t&&`\n       border: 1px solid ${"dark"===i?r.elements.primary.ondark.value:r.elements.primary.onlight.value};\n       box-shadow: 0 0 0 \n        ${o(n.border.width.value)}\n        ${"dark"===i?r.elements.primary.ondark.value:r.elements.primary.onlight.value};;\n     `}};

  ${function({disabled:e,checked:t,$active:i,surface:a}){return!e&&!t&&i&&`\n       border: 1px solid ${"dark"===a?r.elements.primary.ondark.value:r.elements.primary.onlight.value};\n       box-shadow: 0 0 0 \n        ${o(n.border.width.value)}\n        ${"dark"===a?r.elements.primary.ondark.value:r.elements.primary.onlight.value};;\n     `}};

  ${function({disabled:e,checked:r,$active:t,$hovered:i,$borderColor:a,surface:l}){return!e&&!r&&!t&&i&&`\n     &:hover {\n       border: 1px solid ${"dark"===l?n.color.border.ondark.value:a};\n       box-shadow: 0 0 0 \n          ${o(n.border.width.value)}\n          ${"dark"===l?n.color.border.ondark.value:a};;\n     }\n     `}};
  outline: 0;
`,s=i.label.withConfig({displayName:"LabelBase",componentId:"VDS__sc-pgy560-1"})`
  cursor: ${function({disabled:e}){return e?"normal":"pointer"}};
  height: 100%;
  z-index: 1;

  &:active,
  &:hover {
    outline: 0;
  }
`,u=a`
  display: block;
  padding: ${o(n.space.inset.value)};

  .LabelContent {
    display: block;
  }
`,c=i(s).withConfig({displayName:"RadioBoxLabel",componentId:"VDS__sc-pgy560-2"})`
  ${u};
  font-weight: ${function({fontWeight:e}){return e}};
  font-size: ${o(t.fontsize.body[16].value)};
  letter-spacing: ${o(t.letterspacing.wide.value)};
  line-height: ${o(t.lineheight.body[20].value)};
  font-family: ${e.VerizonNHGeDS};
`,h=i(s).withConfig({displayName:"StackedLabel",componentId:"VDS__sc-pgy560-3"})`
  ${u};
  flex-grow: 1;
  font-weight: ${t.fontweight.bold.value};
  font-size: ${o(t.fontsize.body[16].value)};
  letter-spacing: ${o(t.letterspacing.wide.value)};
  line-height: ${o(t.lineheight.body[20].value)};
  font-family: ${e.VerizonNHGeDS};

  > * {
    &:not(:last-child) {
      margin-bottom: ${o(2)};
    }
  }
`,p=i.span.withConfig({displayName:"SubLabel",componentId:"VDS__sc-pgy560-4"})`
  display: block;
  font-size: ${o(t.fontsize.body[16].value)};
  letter-spacing: ${o(t.letterspacing.wide.value)};
  line-height: ${o(t.lineheight.body[20].value)};
  font-family: ${e.VerizonNHGeDS};
  font-weight: ${t.fontweight.regular.value};
  margin: 0;
  pointer-events: none;
`;d.defaultProps={checked:!1,$transparentBackground:!1,disabled:!1};export{c as RadioBoxLabel,d as RadioBoxLabelWrapper,h as StackedLabel,p as SubLabel};
